<template>
	<div class="modal-holder promo-upgrade" :class="{'is-closing': isClosing}" v-if="isVisible">
		<div class="modal-backdrop" @click="close()"></div>
		<div class="modal promo-upgrade">
			<div class="modal-close show-me" @click="close()"><svg><use xlink:href="#cross"></use></svg></div>
			<div class="modal-body upgrade-promo">
				<div class="creative">
					<picture @click="showUpgradeModal()" style="display: block">
						<source media="(max-width: 600px)" :srcset="`${assetBase}/assets/main/images/promo/ccc-promo-modal-mobile@1x.png, ${assetBase}/assets/main/images/promo/ccc-promo-modal-mobile@2x.png 2x`">
						<source media="(min-width: 601px)" :srcset="`${assetBase}/assets/main/images/promo/ccc-promo-modal@1x.png, ${assetBase}/assets/main/images/promo/ccc-promo-modal@2x.png 2x`">
						<img :src="`${assetBase}/assets/main/images/promo/hero-modal.png`" alt="">
					</picture>
				</div>
				<div class="content">
					<h4>Upgrade your Fibre <br />speed for FREE!</h4>
					<h5>Get a free line upgrade until end December 2021</h5>
					<p>As a valued Afrihost client we're giving you the opportunity to upgrade your Fibre package to the next available line speed - for FREE! That's right, if you opt-in now, your speed will be upgraded until 31 December 2021.</p>
					<p>All at no additional cost to you.</p>
					<p class="red">Just another way of giving you even more Pure Internet Joy!</p>
					<div class="content-footer">
						<p class="tcs"><strong>Please note:</strong> This promotion is available for opt-in during the sign up process. Not all Fibre providers qualify for this promotion.</p>
					</div>
				</div>
			</div>
		</div><!-- end.modal -->
	</div><!-- end.modal-holder -->
</template>

<script>

export default {
	components: {

	},
	computed: {
		isVisible() {
			return this.$store.getters['general/upgradeModalVisible'];
		},
		assetBase() {
			return window._assetBaseUrl;
		}
	},
	data() {
		return {
			isClosing: false,
			isLoading: false
		}
	},
	methods: {
		close() {
			this.isClosing = true;
			setTimeout(() => {
				this.$store.commit('general/updateUpgradeModalVisibility', false);
				this.isClosing = false;
			}, 300);
		}
	},
	mounted() {

		this.$on('close', () => {
			this.close();
		});
	}
}
</script>

<style lang="scss">
	.modal.promo-upgrade {
		.modal-close {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 3rem;
			height: 3rem;
			border-radius: 50%;
			background: linear-gradient(to bottom, #df1449, #780121);
			position: absolute;
			top: 0;
			right: 0;
			transform: translateY(-50%) translateX(50%);
			cursor: pointer;
			z-index: 6;

			svg {
				width: 1.2rem;
				height: 1.2rem;
				fill: #fff;
			}
		}
	}
	.modal-body.upgrade-promo {
		display: flex;
		justify-content: space-between;
		width: 106.2rem;
		max-height: 100%;
		padding: 0;

		overflow: hidden;
		border-radius: 1rem;

		.creative {
			width: 42.2rem;
			background-color: #a90440;
			background: radial-gradient(circle at top, rgba(218,60,101,1) 10%, rgba(180,8,72,1) 50%, rgba(122,1,33,1) 100%);
			border-radius: 1rem 0 0 1rem;

			img,
			picture {
				width: 100%;
				display: block;
			}
		}

		.content {
			width: 64rem;
			padding: 6rem 8rem 0 6rem;
		}

		h4 {
			font-size: 5rem;
			line-height: 6.6rem;
			font-weight: bold;
			color: #ff014c;
			background: linear-gradient(to right, #890233 0%, #ff014c 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			display: inline-block;
			margin-bottom: 3.5rem;
		}

		h5 {
			font-size: 1.8rem;
			font-weight: bold;
			line-height: 2rem;
			color: #787878;
			background: none;
			-webkit-background-clip: unset;
			-webkit-text-fill-color: unset;
			margin-bottom: 3rem;
		}

		p {
			font-size: 1.2rem;
			line-height: 2.2rem;
			color: #787878;

			+ p {
				margin-top: 2rem;
			}

			&.red {
				color: #a90440;
			}
		}

		.content-footer {
			margin-top: 3rem;
			padding: 3.5rem 8rem 4rem 6rem;
			margin-left: -6rem;
			margin-right: -8rem;
			background: #fafafa;
			border-top: .1rem solid #f0f1f1;
			border-radius: 0 0 1rem 0;

			p {
				font-size: 1rem;
				line-height: 2rem;
			}
		}

		@media all and (max-width: 600px) {
			flex-direction: column;
			height: 100%;

			.creative {
				width: 100%;
				border-radius: 1rem 1rem 0 0;
			}

			.content {
				width: 100%;
				padding: 5rem 2rem 0 2rem;

				br {
					display: none;
				}
			}

			h4 {
				font-size: 3.2rem;
				line-height: 4.3rem;
			}

			h5 {
				font-size: 1.6rem;
				line-height: 2.6rem;
				color: #787878;
				margin-bottom: 2.5rem;
			}

			.content-footer {
				//margin-top: 3rem;
				padding: 3.5rem 2rem 4rem 2rem;
				margin-left: -2rem;
				margin-right: -2rem;
				border-radius: 0 0 1rem 1rem;
			}
		}
	}

	@media all and (max-width: 600px) {

		.modal-holder.promo-upgrade {
			overflow-y: auto;
			display: block;

			.modal-backdrop {
				display: block;
				position: fixed;
			}
		}

		.modal.promo-upgrade {
			position: relative;
			border-radius: 1rem;
		}

		.modal-close.show-me {
			display: flex;
		}
	}

</style>
